export default {
  title: 'Interaction Hub',
  addMessage: 'Add a message',
  loading: 'Loading...',
  quote_load_error: 'The project submission could not be loaded. Please try again.',
  noInteractions: 'No interactions yet',
  loadMore: 'Load more',
  messageFrom: 'Message from {{name}}',
  yourMessage: 'Your message',
  documentAdded: '{{name}} added a document',
  submitMessage: 'Send',
  attachFile: 'Attach file',
  messagePlaceholder: 'Write your message...',
  messageOrAttachmentRequired: 'Please write a message or attach a file',
  fileTooLarge: 'File size must not exceed 50MB',
  viewHub: 'View details',
  interactionTypes: {
    new_job_posted: 'Job offer published',
    quote_request_received: 'Submission request sent',
    quote_request_received_recruiter: 'Submission request sent',
    quote_request_received_freelancer: 'Submission request received',
    quote_request_received_sent: 'Submission request sent',
    quote_request_received_received: 'Submission request received',
    quote_submitted: 'Freelancer quote received',
    quote_submitted_sent: 'Quote submitted',
    quote_submitted_received: 'Freelancer quote received',
    child_quote_submitted: 'Freelancer quote received',
    child_quote_submitted_sent: 'Alliance quote submitted',
    child_quote_submitted_received: 'Freelancer quote received',
    child_quote_accepted: 'Freelancer quote accepted',
    quote_accepted: 'Submission accepted, project has started',
    quote_change_requested: 'Change request',
    quote_change_requested_sent: 'Change request sent',
    quote_change_requested_received: 'Change request received',
    adjustment_submitted: 'Adjustment submitted',
    adjustment_submitted_sent: 'Adjustment sent',
    adjustment_submitted_received: 'Adjustment received',
    adjustment_title: 'My adjustment',
    hub_message: 'Message',
    project_status_updated: 'Project status updated',
    project_completed: 'Project completed',
    project_cancelled: 'Project cancelled',
    message_from: 'Message from {{name}}',
    parent_quote_submitted: 'Submission sent to recruiter',
    parent_quote_accepted: 'The recruiter has accepted your submission',
    new_contact_added: 'New contact created',
    quote_request_accepted: 'Submission request accepted',
    quote_alliance_accepted: 'Project invitation accepted',
    quote_alliance_rejected: 'Project invitation rejected',
    quote_alliance_retired: 'Project invitation retired',
    quote_alliance_invited: 'Project invitation received',
    quote_alliance_invited_sent: 'Project invitation sent',
    quote_alliance_invited_received: 'Project invitation received',
    job_selection_period_started_for_applicant: 'Quote review started',
  },
  submission_tracking: 'Submission tracking',
  interaction_history: 'Interaction history with freelancers',
  submission_type_list: {
    direct_request: 'Direct request',
    received_application: 'Received application',
  },
  submission_type_title: 'Submission type',
  offer: 'Offer',
  received_date: 'Received date',
  team: 'Team',
  contacts: 'Contacts',
  project_details: 'Project details',
  job_description: 'Job description',
  noSubmissionTracking: 'There are no submissions at the moment',
  oneOfferHide: '1 offer hidden',
  multipleOffersHide: '{{count}} offers hidden',
  acceptedOffer: 'Accepted offer',
  principal_freelancer: 'Principal freelancer',
  total: 'Total amount',
  see_details: 'See details',
  quote_accepted: 'quote accepted',
  quote_rejected: 'quote rejected',
  quote_pending: 'quote pending',
  no_history: 'There are no interactions at the moment',
  time_ago: {
    just_now: 'just now',
    seconds_ago: '{{count}} seconds ago',
    a_minute_ago: 'a minute ago',
    minutes_ago: '{{count}} minutes ago',
    an_hour_ago: 'an hour ago',
    hours_ago: '{{count}} hours ago',
    a_day_ago: 'a day ago',
    days_ago: '{{count}} days ago',
    a_week_ago: 'a week ago',
    weeks_ago: '{{count}} weeks ago',
    a_month_ago: 'a month ago',
    months_ago: '{{count}} months ago',
    a_year_ago: 'a year ago',
    years_ago: '{{count}} years ago',
  },
  new_label: 'New',
  Alliances: 'Alliances',
  submission_accepted_hint: 'Submission from {{name}} accepted, project has started',
  quoteSnapshot: {
    title: 'Quote before change request',
    teamSectionLabel: 'Team quotes',
    teamMemberLabel: 'Team member',
  },
  project_tracking: 'Project tracking',
  project_interaction_history: 'Interaction history',
  role: {
    principal: 'Principal freelancer',
    alliance: 'Alliance',
  },
} as const;
